import { useMutation } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface UpgradeUserParams {
  customerId: string;
  plan: string;
  isAnnual?: boolean;
}

const upgradeUser = (params: UpgradeUserParams) =>
  httpService.post(`${BASE_URL}/api/v1/user/${params.customerId}/profile`, {
    customerProfileData: params.plan,
    isAnnual: params.isAnnual || false,
  });

export const useUpgradePlan = () => useMutation('upgradePlan', upgradeUser);
